export default {
  agentProvider: {
    application: 'Master Franchisee Service Provider Application',
    applicationEdit: 'Edit Master Franchisee Service Provider Application',
    agent: 'Master Franchisee',
    agentType: 'Master Franchisee Type',
    period: 'Term',
    bufferPeriod: 'Grace Period',
    remark: 'Notes',
    subscribeRegion: 'Territory',
    totalAmount: 'Total Amount',
    periodEndTime: 'Term End Date',
    pleaseSelectAgent: 'Select Master Franchisee',
    pleaseSelectAgentType: 'Select Master Franchisee Type',
    pleaseSelectPeriod: 'Select Term',
    pleaseSelectStatus: 'Select Status',
    pleaseEnterAmount: 'Enter total amount',
    pleaseEnterBufferPeriod: 'Enter grace period',
    pleaseEnterShareholdingRatio: 'Enter ownership percentage',
    pleaseEnterRemark: 'Enter notes',
    pleaseSelectRegion: 'Select State / City / ZIP Code',
    campusId: 'Master Franchisee ID',
    campusName: 'Master Franchisee Name',
    districts: 'Selected Territories',
    amount: 'Total Purchase Amount',
    rechargeAmount: 'Paid Purchase Amount',
    goldAmount: 'Remaining Unused Amount',
    retainAmount: 'Required Reserve Amount',
    openStatusName: 'Status',
    to: 'to',
    startDate: 'Start Date',
    endDate: 'End Date',
    orgTypeLabel: 'Organization Type:',
    pleaseSelectOrgType: 'Select organization type',
    pleaseSelectOrgLocation: 'Select location',
    signTimeLabel: 'Contract Signed Date:',
    pieceNameLabel: 'Territory Name:',
    pleaseEnterPieceName: 'Enter territory name',
    createTimeLabel: 'Created Time:',
    contractStatusLabel: 'Contract Status:',
    pleaseSelectContractStatus: 'Select contract status',
    handStatusLabel: 'Handover Status:',
    pleaseSelectHandStatus: 'Select handover status',
    openStatusLabel: 'Operational Status:',
    pleaseSelectOpenStatus: 'Select operational status',
    openTimeLabel: 'Opening Date:',
    pleaseSelectCreator: 'Select creator',
    pleaseSelectOperator: 'Select operator',
    chargeStateLabel: 'Billing Status:',
    pleaseSelectChargeState: 'Select billing status',
    chargePlanLabel: 'Billing Plan:',
    pleaseSelectChargePlan: 'Select billing plan',
    isFreeMonthLabel: 'Fee Exemption:',
    pleaseSelectIsFreeMonth: 'Select fee exemption option',
    freeEndTimeLabel: 'Fee Exemption End Date:',
    overallPlannerLabel: 'Program Coordinator:',
    pleaseSelectOverallPlanner: 'Select program coordinator',
    supportStaffLabel: 'Support Staff:',
    pleaseSelectSupportStaff: 'Select support staff',
    participateTypeLabel: 'HQ Lead Distribution Plan:',
    pleaseSelectParticipateType: 'Select HQ lead distribution plan',
    schoolGradeLabel: 'Organization Tier:',
    pleaseSelectSchoolGrade: 'Select organization tier',
    orignSignMainNameLabel: 'Original Legal Entity Name:',
    schoolStatusLabel: 'Organization Account Status:',
    pleaseSelectSchoolStatus: 'Select organization account status',
    campusLabelLabel: 'Organization Tags:',
    pleaseSelectCampusLabel: 'Select organization tags',
    orgType: 'Organization Type',
    orgLocation: 'Location',
    signTime: 'Contract Signed Date',
    pieceName: 'Territory Name',
    supportStaffName: 'Support Staff',
    contractStatus: 'Contract Status',
    handStatus: 'Handover Status',
    isFreeMonth: 'Fee Exemption',
    freeTime: 'Fee Exemption Period',
    chargePlan: 'Billing Plan',
    chargeState: 'Billing Status',
    schoolGrade: 'Organization Tier',
    openStatus: 'Operational Status',
    actualOpenTime: 'Opening Date',
    schoolStatus: 'Organization Account Status',
    participateType: 'HQ Lead Distribution Plan',
    signMainTypeName: 'Contract Entity Type',
    signMainName: 'Contract Entity Name',
    orignSignMainTypeName: 'Original Legal Entity Type',
    orignSignMainName: 'Original Legal Entity Name',
    contactNo: 'Signer Phone Number',
    idCard: 'Government ID Number',
    address: 'Signer Address',
    refundStatusName: 'Refund Status',
    lastUpdateUserName: 'Last Updated By',
    lastUpdateTime: 'Last Updated Time',
    createUserName: 'Created By',
    createTime: 'Created Time',
    orgInfo: 'Organization Information',
    orgDataReport: 'Organization Data Report',
    batchAdd: 'Bulk Add',
    quickSearchPlaceholder: 'Enter Organization ID, Name, Contract Entity Name, or ID Number',
    quickSearch: 'Quick Search',
    advancedSearch: 'Advanced Search',
    clearFilter: 'Clear Filters',
    orgIdCol: 'Organization ID',
    orgNameCol: 'Organization Name',
    viewDetail: 'View Details',
    refund: 'Refund',
    assignCourses: 'Assign Courses',
    areaRelease: 'Release Territory',
    operatePine: 'Manage Points',
    closeOrgAccount: 'Deactivate Organization Account',
    openOrgAccount: 'Activate Organization Account',
    batchCreateAgentTitle: 'Bulk Create Master Franchisees',
    downloadTemplateTip: 'To download the template, click:',
    downloadImportTemplate: 'Download Import Template',
    selectFileToImport: 'Select a file to import and start uploading',
    dragOrClickUpload: 'Drag files here or',
    clickUpload: 'Click to Upload',
    importCompleteViewDetail: 'Import complete. Click to view details',
    importDetail: 'Import Details',
    tip: 'Notice',
    confirmSubmitOrgTip: 'Confirm submission of "{signMainTypeName}-{signMainName}"? You can complete organization details after submission.',
    confirmCloseOrgAccount: 'Are you sure you want to deactivate this organization account?',
    confirmOpenOrgAccount: 'Are you sure you want to activate this organization account?',
    closeOrgAccountDesc1: 'After deactivation, all staff accounts will be unable to log in to the Organization Admin Portal,',
    closeOrgAccountDesc2: 'Principal Portal, and Teacher Portal. Student accounts will also be unable to access the Student Portal.',
    closeReasonLabel: 'Reason for Deactivation:',
    pleaseEnterReason20: 'Enter reason (max 20 characters)',
    openOrgAccountDesc1: 'After activation, all staff accounts will regain access to the Organization Admin Portal,',
    openOrgAccountDesc2: 'Principal Portal, and Teacher Portal. Student accounts will be able to access the Student Portal.',
    verifyTip: 'Verification',
    pleaseCheckSms: 'Please check the SMS sent to {phone}',
    pleaseEnterFourDigitCode: 'Enter the 4-digit verification code',
    codeSentSuccess: 'Verification code sent successfully',
    codeSendFailed: 'Failed to send verification code',
    courseAssignSuccess: 'Courses assigned successfully',
    courseAssignFail: 'Failed to assign courses',
    onlyXlsXlsxFormat: 'Only .xls or .xlsx files are supported',
    importFail: 'Import failed',
    submitSuccess: 'Submitted successfully',
    rechargeNo: 'Transaction ID',
    rechargeNoLabel: 'Recharge Transaction',
    pleaseEnterRechargeNo: 'Enter transaction ID',
    accountType: 'Account Type',
    pleaseSelectAccountType: 'Select account type',
    payMethod: 'Payment Method',
    goldAccountRechargeRecord: 'Gold Account Recharge History',
    serviceProviderRights: 'Service Provider Benefits',
    goldAccountExpenseRecord: 'Gold Account Expense History',
    goldAccount: 'Gold Account',
    accountBalance: 'Account Balance',
    yuan: '$',
    totalPaymentAmount: 'Total Purchase Amount',
    paidPaymentAmount: 'Paid Purchase Amount',
    retainPaymentAmount: 'Reserved Purchase Amount',
    serviceRegion: 'Service Territory',
    retainBalance: 'Required Reserve Balance',
    purchaseProduct: 'Product',
    purchaseQty: 'Quantity',
    purchaseAmount: 'Purchase Amount',
    goldAccountPayAmount: 'Gold Account Payment',
    voucherAccountPayAmount: 'Referral Bonus Account Payment',
    cashPayAmount: 'Cash Payment',
    payMethodLabel: 'Payment Method',
    lastPayTime: 'Last Payment Time',
    voucherBonusAccount: 'Referral Bonus Account',
    payTimeLabel: 'Payment Time',
    rechargeAmount: 'Recharge Amount',
    payTime: 'Recharge Time',
    pleaseSelectAgentLevel: 'Select Master Franchisee Level',
    pleaseEnterReceiverName: 'Enter recipient name',
    pleaseEnterReceiverPhone: 'Enter recipient phone number',
    pleaseEnterReceiverAddress: 'Enter shipping address',
    pleaseEnterDealerId: 'Enter Franchisee ID',
    agentTypeFieldLabel: 'Agent type:',
    agentLevelFieldLabel: 'Agent level:',
    consigneeFieldLabel: 'Consignee:',
    consigneeMobileFieldLabel: 'Consignee mobile:',
    consigneeAddressFieldLabel: 'Consignee address:',
    dispatchRuleFieldLabel: 'Dispatch rule:',
    deviceVersionFieldLabel: 'Device version:',
    dealerIdFieldLabel: 'Franchisee ID:',
    pleaseSelectDispatchRule: 'Select dispatch rule',
    pleaseSelectDeviceVersion: 'Select device version',
    pleaseEnterAgentId: 'Enter Master Franchisee ID',
    pleaseSelectContractType: 'Select contract type',
    pleaseSelectFileType: 'Select file type',
    pleaseSelectCampusNature: 'Select Learning Center type',
    pleaseEnterCampusName: 'Enter Learning Center name',
    pleaseSelectMaterialType: 'Select material type',
    pleaseSelectInvoiceType: 'Select invoice type',
    ke: 'Customer Support',
    pleaseSelect: 'Select Learning Center',
    all: 'All',
    not: 'Not Signed In',
    idle: 'Idle',
    busy: 'Busy',
    ing: 'On Call',
    adPosition: 'Ad Placement',
    name: 'Enter school name',
    onShelf: 'Published',
    offShelf: 'Unpublished',
    tai: 'Login Page Banner',
    loginFloatWindow: 'Login Page Pop-up',
    bu: 'Bottom Banner',
    fullscreenPopup: 'Fullscreen Pop-up',
    miniProgramHome: 'Mini Program Home',
    miniProgramSquirrelCup: 'Mini Program Squirrel Cup',
    time: 'Fee Exemption End Date:',
    ru: 'Inbound Call',
    chu: 'Outbound Call',
    di: 'Location:',
    chuangjian: 'Created By:',
    pricingPlan: 'Billing Plan:',
    yes: 'Yes',
    ji: '5-Star',
    orgTag: 'Organization Tags:',
    zongbu: 'Headquarters Lead Distribution Plan:',
    jiao: 'Formally Handed Over',
    free: 'Free',
    paid: 'Paid',
    no: 'No',
    normal: 'Active',
    closed: 'Closed',
    participate: 'Participating',
    notParticipate: 'Not Participating',
    xuexiaoxueduan: 'School Grade Level',
    xue: 'School Type',
    boardingStatus: 'Boarding Status',
    school: 'Associated Learning Center',
    public: 'Public',
    private: 'Private',
    international: 'International',
    tizonge: 'Total Purchase Amount',
    order: 'Total Paid Order Amount',
    equityRatio: 'Ownership Percentage',
    purchase: 'Purchase Order No.',
    recharge: 'Payment Method:',
    caozuo: 'Operator',
    pleaseEnter: 'Enter transaction ID',
    add: 'Add',
    textruia: 'Form',
    operation: 'Actions',
    textsuxt: 'File',
    textje8x: 'File Name',
    textd6a5: 'Size',
    text5jw7: 'Total Data Length',
    delete: 'Delete',
    hour: 'Search may be triggered by this component',
    minhour: 'During pagination',
    houryici: 'Reuse previous parameters',
    texts3fo: 'File',
    textjrfo: 'Download failed',
    textla8q: 'Deleted successfully',
    textl5ao: 'Delete failed',
    back: 'Back',
    textdhve: 'Contract Basic Information',
    textp0hg: 'Master Franchisee Information',
    textr0jm: 'Initial Account Balance',
    text03wh: 'Contract Basic Details',
    text83nw: 'Order Information',
    textnpnc: 'Learning Center Entity',
    hao: 'Account Information',
    text7kqa: 'Contact Information',
    text77h0: 'Learning Center Basic Information',
    textj19e: 'Curriculum Version Information',
    textujbu: 'Learning Center Device Information',
    textchvw: 'Pricing and System Information',
    texttdzq: 'Document Information',
    textykpz: 'Organization Contract Information',
    textatrk: 'Organization Basic Information',
    textxdk4: 'Organization Detailed Information',
    textjqma: 'Initial Amount',
    textjfhw: 'Contract Department',
    textjku3: 'Coordinating Department',
    textmffo: 'Create',
    edit: 'Edit',
    preview: 'Preview',
    textwhr8: 'Invoice Required',
    texthy28: 'Expand Contract Information',
    textmds2: 'Expand Organization Information',
    textb1hd: 'Is Learning Center',
    texte1p3: 'In Beta Program',
    text5k7q: 'For Development Testing',
    text5ozx: 'Retrieve Default Invoice Setting',
    textjhfo: 'Fetch',
    textjac1: 'Retrieve Official Organization Info',
    textkve0: 'Retrieve Squirrel Organization Info',
    textaiw3: 'Retrieve Full Address',
    texts52f: 'Retrieve Organization Name',
    textjeun: 'Retrieve Organization Type',
    textd5or: 'Toggle Contract Information',
    yi: 'Back to Previous Page',
    textmkpt: 'Contract Information',
    signingEntity: 'Contracting Entity',
    texta293: 'Individual',
    textqrvk: 'Legal Representative Name',
    textqrpg: 'Email Address',
    text0qu2: 'Signer Address',
    text79cm: 'Multi-Center Search',
    textcfao: 'Contract Entity Change Status',
    textpsfg: 'Unchanged',
    texthtif: 'Changed',
    text8f1k: 'Change Details',
    text91mm: 'Business License Attachment',
    text20hu: 'Click to View',
    textfa0i: 'Multiple Centers',
    text9hud: 'Location',
    text0fdp: 'Contract Status',
    textdst0: 'Discounted Contract',
    text41xd: 'Equity Amount',
    textpze9: 'Signing Manager',
    textc148: 'Regional Tier Standard',
    signAmount: 'Contract Amount',
    textb7f1: 'Amount Received',
    texta9pu: 'Fee Waiver Period',
    month: 'months',
    textenfo: 'Site Selection Staff',
    marketSubsidyFee: 'Marketing Subsidy Fee',
    textf1tq: 'Regional Tier Standard Description',
    text739o: 'Contracted Region Name',
    textwjlv: 'Contract Deposit',
    textey7d: 'Preparation Period',
    text61bh: 'Learning Center Tag',
    textpavs: 'Contract Information',
    text3pv0: 'Contract Attachments',
    textgk5w: 'Additional Document Signing Information',
    download: 'Download',
    textgdcv: 'Invoice Information',
    textkwte: 'Refund Information',
    text89j4: 'Total Refund Amount',
    textfib2: 'Actual Refund Amount',
    text057g: 'Refund Method',
    yihour: 'First Disbursement Date',
    textuki5: 'Refund Installment',
    textsosh: 'Deduction Amount',
    text4s0r: 'Refund Reason',
    textxil0: 'Equity Conversion Option',
    textbwlu: 'Payment Status',
    erhour: 'Second Disbursement Date',
    texte2qc: 'Release Status',
    textx43c: 'Disbursement Status',
    text3d6g: 'Disbursement Installment',
    textuag3: 'Disbursement Information',
    textvj4l: 'Post-Release Learning Center Information',
    text61e8: 'Multi-Center Search Dialog',
    text03kt: 'Change Details Dialog',
    campus: 'Learning Center',
    textzt0d: 'Contracting Entity Type',
    textt5tl: 'Contract Name',
    textnicu: 'Reason for Change',
    textq8j4: 'Contract Type',
    text1wvm: 'Contract Title',
    contractCode: 'Contract ID',
    text0z7q: 'Contract Value',
    textvnxs: 'Contract Signing Manager',
    creator: 'Created By',
    textisrt: 'Last Updated By',
    textzc5z: 'File Type',
    text3bk2: 'File Purpose',
    text744a: 'Document Signing Manager',
    customerName: 'Customer Name',
    mobile: 'Phone Number',
    textkg1z: 'Order Status',
    textox83: 'Order Amount',
    text757y: 'Deposit',
    textiikg: 'Amount Received',
    texty5vn: 'Source',
    text48iv: 'Invoice Type',
    textr252: 'Invoice Amount',
    text8lmk: 'Invoice Title',
    textsgpq: 'Refund Amount',
    texts2wm: 'Payout Amount',
    text5l9n: 'Post-Release Learning Center',
    settlementAmount: 'Settlement Amount',
    textu1rd: 'Guaranteed Amount',
    textvd7y: 'Show Full ID Number',
    textvjsy: 'Contracting Entity',
    texto62c: 'Show Contact Information',
    textomko: 'Attachment URL',
    textzjva: 'Contracting Entity Information',
    text62wo: 'Region Release Information',
    text9gt7: 'Post-Release Learning Center Information',
    textla60: 'Breadcrumb',
    textmtpl: 'Page Title',
    textthsl: 'Legal Entity',
    textr61k: 'Organization',
    textdhsa: 'Organization Type',
    textdujb: 'Organization Rating',
    textdtnm: 'Full Address',
    textzgvh: 'View Location',
    textgey9: 'Support Staff',
    text5l3n: 'Formal Handover',
    textbhjz: 'Pre-Handover',
    text9ln6: 'Operational Status',
    textelby: 'Reason',
    textavtk: 'Full Name',
    text1hmx: 'Contact Information',
    text6rts: 'Expand',
    textfwb7: 'Collapse',
    textqtqr: 'Contact Name',
    textzjio: 'Contact Phone',
    textoncj: 'Admissions Phone',
    textk7b6: 'Admissions Email',
    textf4vr: 'Facility Area',
    textrpxj: 'Number of Classrooms',
    textlojp: 'Maximum Capacity',
    textu0d7: 'Rent',
    textfc2o: 'Renovation Status',
    text767v: 'Not Renovated',
    textlfac: 'Under Renovation',
    textkk3y: 'Renovation Completed',
    text4ch9: 'Phone',
    texto9g2: 'Bank Name',
    text618k: 'Recipient Name',
    text8k5h: 'Recipient Contact',
    textzm06: 'Shipping Address',
    texta3pj: 'Company',
    textcnn5: 'Account Name',
    textxh2u: 'Entity Name',
    textrran: 'Bank Name',
    textos3a: 'Organization Curriculum Information',
    textq675: 'Organization Device Information',
    textpuci: 'Computer',
    text6iyx: 'Telephone Device',
    text73vu: 'Time Clock',
    text8f7w: 'Writing Tablet',
    textd0tr: 'Camera',
    text40sa: 'Billing',
    textlea8: 'Pricing Plan',
    text8655: 'Pricing Coefficient',
    textadyx: 'Headquarters Online Payment',
    textlnz6: 'Enable',
    close: 'Disable',
    textrnuy: 'Auto Recharge Deduction Ratio',
    texth9ug: 'Merchant',
    textxihj: 'Organization Tag',
    textr4ty: 'Enable Small Group Classes',
    textbo6m: 'Small Group (Elementary) Base Price',
    textwsjq: 'Small Group (Middle School) Base Price',
    textzaqr: 'Small Group (High School) Base Price',
    textl0oq: 'Small Group (Elementary) Price',
    textu62b: 'Small Group (Middle School) Price',
    text5orh: 'Small Group (High School) Price',
    textitua: 'Enable Large Group Classes',
    textcyos: 'Large Group (Elementary) Price',
    text3qnh: 'Large Group (Middle School) Price',
    text699x: 'Large Group (High School) Price',
    textwgk1: 'Headquarters',
    text6gu8: 'Campaign Plan',
    textxg3q: 'Claim Limit',
    day: 'Per Day',
    text1ewz: 'Attachments',
    text08n9: 'Materials',
    text3hl2: 'Output',
    textaq4e: 'Basic Information',
    textlm5i: 'Handover Information',
    textwuc5: 'Organization Address Location',
    text460s: 'Device Information',
    textc5i7: 'Curriculum Version',
    texte7wu: 'Material Type',
    textz96b: 'Material Name',
    text6sic: 'Uploaded By',
    textsq7r: 'Component Function',
    text1quf: 'Query Information',
    text2dm7: 'Query Organization Handover Information',
    textq34k: 'Query Contact Information',
    textulvb: 'Query Organization Basic Information',
    textz8kw: 'Query Pricing and System Information',
    textblng: 'Query Organization Materials',
    text5y1x: 'Region Information',
    textyqix: 'Keyword',
    textpxms: 'Edit Region',
    textnn3r: 'Edit Learning Center Region',
    text8017: 'Reward Ratio',
    textpatt: 'TBD',
    text85yl: 'Unsubscribe',
    text7sbf: 'Lead Information',
    textl2db: 'Lead Status',
    textzbos: 'Referring Agent Information',
    textctrb: 'Referrer',
    textbp5e: 'Referrer Region',
    textn7fx: 'Referrer Name',
    textgqvh: 'Referrer Phone',
    texttn6m: 'Customer Communication Screenshot',
    textluet: 'Reward Method Information',
    text2gmn: 'Reward Method',
    textg4a9: 'Payout Agent',
    textjq5l: 'Payout Agent Name',
    textxrvp: 'Submitting Agent Information',
    text6sv4: 'Submitting Agent',
    text8rfe: 'Submitting Agent Name',
    text2r13: 'Submitting Agent Region',
    texttx22: 'Customer Information',
    text9eht: 'Customer Phone',
    text54zu: 'Customer Region',
    textzb3a: 'Customer Background Information',
    textdr39: 'Follow-up Information',
    textpe5s: 'Follow-up Staff Name',
    texttkfu: 'Follow-up Communication Screenshot',
    textoryd: 'Review Information',
    text3oqz: 'Review Comments',
    applicationTime: 'Application Time',
    submitTime: 'Submission Time',
    auditTime: 'Review Time',
    pleaseSelectLeadStatus: 'Select Lead Status',
    introducerAgentId: 'Referring Agent ID',
    introducerAgentName: 'Referring Agent Name',
    introducerAgentRegion: 'Referring Agent Region',
    withdrawAgentId: 'Payout Agent ID',
    pleaseSelectRewardMethod: 'Select Reward Method',
    textxphb: 'Channel Partner Application',
    textoqrs: 'View Agreement',
    details: 'Details',
    texthfj9: 'Upgrade Modal',
    texth9mi: 'Upgrade To',
    text8wsx: 'Required Quota for Upgrade',
    text64ye: 'Current Level',
    textzsod: 'Available Quota',
    textn4ks: 'Click',
    confirm: 'Confirm',
    textlitm: 'to submit the application to the Nuwa system',
    texteair: 'Only',
    texts9bh: 'Franchisees at Level',
    textctyl: 'and above are eligible to apply for Channel Partner',
    text2e0n: 'Your current Franchisee level',
    textd2u8: 'is',
    textzmer: 'not eligible for application',
    textt2ad: 'Account Activity Notification',
    advertName: 'Ad Name',
    confirmAdvertStatus: 'Confirm Status',
    auto_1_381101ee: 'Purchase Order No.1',
    auto_2_2f5d5b8b: 'Purchased Product 2',
    auto_3_e6944985: 'Quantity 3',
    auto_4_117e0685: 'Purchase Amount 4',
    auto_5_72a6f3c8: 'Gold Account Payment Amount 5',
    auto_6_2263f7d9: 'Referral Account Payment Amount 6',
    auto_7_e571c196: 'Cash Payment Amount 7',
    auto_8_5cc0a006: 'Payment Method 8',
    auto_9_272f0d73: 'Last Payment Date 9',
    auto_10_a40d69ff: 'Operator 10',
    auto_11_4b30c5c0: 'Remarks 11',
    auto_12_d632128e: 'Master Franchisee 12',
    auto_13_d103286a: 'Master Franchisee Name 13',
    auto_14_5c3b120e: 'Service Region 14',
    auto_15_6ba7cab2: 'Total Prepaid Amount 15',
    auto_16_79db4cda: 'Amount Paid 16',
    auto_17_236f815d: 'Reserved Balance 17',
    auto_18_58acb097: 'Status 18',
    auto_19_e4e29a3c: 'Term 19',
  },
}
